import {DescriptorFacetConfig} from './descriptor-facet-config.model';
import {FiltersConfig} from './filters-config.model';

export class DescriptorsFacetConfig {

  private configMap = new Map<String, DescriptorFacetConfig>();

  getConfig(key: string): DescriptorFacetConfig {
    return this.configMap.get(key);
  }

  putConfig(key: string, config: DescriptorFacetConfig) {
    this.configMap.set(key, config);
  }

  getFacetsConfig(key: string){
    const descrFacetConfig = this.configMap.get(key);
    if (descrFacetConfig){
      return descrFacetConfig.facets;
    }else{
      return new FiltersConfig({});
    }
  }

}
